import { BlogIndexPage } from "@/components/blog/blog-pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/registrant/blog/")({
  component: () => (
    <BlogIndexPage portal="registrant" basePath="/registrant/blog" />
  ),
});
